import { render, staticRenderFns } from "./ResearchItem.vue?vue&type=template&id=520e6d9e&scoped=true&"
import script from "./ResearchItem.vue?vue&type=script&lang=js&"
export * from "./ResearchItem.vue?vue&type=script&lang=js&"
import style0 from "./ResearchItem.vue?vue&type=style&index=0&id=520e6d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e6d9e",
  null
  
)

export default component.exports